<template>
  <div class="news-admin">
    <div class="action-bar">
      <el-button type="primary" @click="showAddDialog">添加新闻</el-button>
    </div>

    <!-- 新闻列表 -->
    <el-table
      :data="newsList"
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column
        label="序号"
        width="80"
        type="index"
      ></el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        min-width="200"
      ></el-table-column>
      <el-table-column
        prop="subtitle"
        label="副标题"
        min-width="250"
      ></el-table-column>
      <el-table-column
        prop="link"
        label="链接"
        min-width="200"
      >
        <template slot-scope="scope">
          <el-link v-if="scope.row.link && isValidUrl(scope.row.link)" :href="scope.row.link" target="_blank" type="primary">
            查看链接
          </el-link>
          <span v-else-if="scope.row.link" class="invalid-link" :title="scope.row.link">
            无效链接
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="创建时间"
        width="180"
      >
        <template slot-scope="scope">
          {{ formatDate(scope.row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.row)"
          >编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :page-sizes="[5, 10, 20, 50]"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      ></el-pagination>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%">
      <el-form :model="newsForm" ref="newsForm" label-width="100px" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input v-model="newsForm.title" placeholder="请输入新闻标题"></el-input>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="newsForm.subtitle" placeholder="请输入新闻副标题"></el-input>
        </el-form-item>
                <el-form-item label="外部链接">
          <el-input 
            v-model="newsForm.link" 
            placeholder="请输入完整的外部链接地址（如：https://example.com）"
            @blur="validateLink"
          ></el-input>
          <div v-if="linkError" class="link-error">{{ linkError }}</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'WebsiteNewsAdmin',
  data() {
    return {
      newsList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      loading: false,
      dialogVisible: false,
      dialogTitle: '添加新闻',
      isEdit: false,
      newsForm: {
        id: null,
        title: '',
        subtitle: '',
        link: ''
      },
      linkError: '',
      rules: {
        title: [
          { required: true, message: '请输入新闻标题', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.fetchNewsList();
  },
  methods: {
    // 验证URL是否有效
    isValidUrl(string) {
      if (!string) return true; // 空值认为是有效的（可选字段）
      try {
        const url = new URL(string);
        return url.protocol === 'http:' || url.protocol === 'https:';
      } catch (_) {
        return false;
      }
    },
    
    // 验证链接格式
    validateLink() {
      if (!this.newsForm.link) {
        this.linkError = '';
        return;
      }
      
      if (!this.isValidUrl(this.newsForm.link)) {
        this.linkError = '请输入完整的URL地址，包含http://或https://';
      } else {
        this.linkError = '';
      }
    },
    
    // 格式化日期
    formatDate(dateString) {
      const date = new Date(dateString);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    },
    
    // 获取新闻列表
    async fetchNewsList() {
      this.loading = true;
      try {
        const response = await request.get(`/api/admin/news?page=${this.currentPage}&limit=${this.pageSize}`);
        this.newsList = response.data.data;
        this.total = response.data.total;
      } catch (error) {
        console.error('获取新闻列表失败:', error);
        this.$message.error('获取新闻列表失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 分页处理
    handleCurrentChange(page) {
      this.currentPage = page;
      this.fetchNewsList();
    },
    
    // 每页显示条数改变
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1; // 重置到第一页
      this.fetchNewsList();
    },
    
    // 显示添加对话框
    showAddDialog() {
      this.isEdit = false;
      this.dialogTitle = '添加新闻';
      this.newsForm = {
        id: null,
        title: '',
        subtitle: '',
        link: ''
      };
      this.dialogVisible = true;
    },
    
    // 编辑新闻
    async handleEdit(row) {
      this.isEdit = true;
      this.dialogTitle = '编辑新闻';
      
      try {
        const response = await request.get(`/api/admin/news/${row.id}`);
        this.newsForm = { ...response.data };
        this.dialogVisible = true;
      } catch (error) {
        console.error('获取新闻详情失败:', error);
        this.$message.error('获取新闻详情失败');
      }
    },
    
    // 删除新闻
    handleDelete(row) {
      this.$confirm('确定要删除这条新闻吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await request.delete(`/api/admin/news/${row.id}`);
          this.$message.success('删除成功');
          this.fetchNewsList();
        } catch (error) {
          console.error('删除新闻失败:', error);
          this.$message.error('删除新闻失败');
        }
      }).catch(() => {
        // 取消删除
      });
    },
    
    // 提交表单
    submitForm() {
      this.$refs.newsForm.validate(async (valid) => {
        if (valid) {
          try {
            if (this.isEdit) {
              // 更新新闻
              await request.put(`/api/admin/news/${this.newsForm.id}`, this.newsForm);
              this.$message.success('新闻更新成功');
            } else {
              // 创建新闻
              await request.post('/api/admin/news', this.newsForm);
              this.$message.success('新闻创建成功');
            }
            
            this.dialogVisible = false;
            this.fetchNewsList();
          } catch (error) {
            console.error('保存新闻失败:', error);
            this.$message.error('保存新闻失败');
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.news-admin {
  padding: 20px;
}

.action-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
}

.invalid-link {
  color: #f56c6c;
  cursor: help;
  font-size: 12px;
}

.link-error {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 5px;
}
</style>